import { render, staticRenderFns } from "./batchImportClips.vue?vue&type=template&id=04059a2f&scoped=true"
import script from "./batchImportClips.vue?vue&type=script&lang=js"
export * from "./batchImportClips.vue?vue&type=script&lang=js"
import style0 from "./batchImportClips.vue?vue&type=style&index=0&id=04059a2f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04059a2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04059a2f')) {
      api.createRecord('04059a2f', component.options)
    } else {
      api.reload('04059a2f', component.options)
    }
    module.hot.accept("./batchImportClips.vue?vue&type=template&id=04059a2f&scoped=true", function () {
      api.rerender('04059a2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/batchImportClips.vue"
export default component.exports